var apiUrl = process.env.REACT_APP_API_URL;

if (apiUrl === undefined) {
    apiUrl = "https://www.admin.traqdo.com";
     //apiUrl = "http://192.168.1.9:8000";
}

export const baseURL = apiUrl;

// export const baseURL = 'https://www.admin.traqdo.com';